import moment from 'moment'

export default function (datetime) {
  if (!datetime) {
    return null
  }

  return moment(datetime, moment.ISO_8601).format('DD.MM.YYYY HH:mm')
}
